import React from 'react';
import WorkflowLoader from '../components/WorkflowLoader';

const CONTAINER_SX = { transform: 'translateY(-32px)', gap: 4 };
const MESSAGE_SX = { fontSize: '20px' };

export default function SRDataImportLoader() {
    return <WorkflowLoader containerSx={CONTAINER_SX} messageSx={MESSAGE_SX} />;
}